import React, { FC } from 'react';

import VaultCard from '../VaultCard/VaultCard';
import { useUserContext } from '../../contexts/UserContext';

import styles from './VaultsList.module.scss';

interface Props {
  vaults: any;
}

const VaultsList: FC<Props> = ({ vaults }) => {
  const { isWalletConnected } = useUserContext();

  return (
    <div>
      <div className={styles.header}>
        <div className={styles.nameSection}>
          <div className={styles.nameSectionContent}>
            <button className={styles.headerBtn} type="button">
              Vault Name
            </button>
          </div>
        </div>

        <div className={styles.tagSection} />

        <div className={styles.rewardsSection}>
          <div className={styles.rewardsSectionContent}>
            <button className={styles.headerBtn} type="button">
              Rewards
            </button>
          </div>
        </div>

        {isWalletConnected && (
          <div className={styles.investmentsSection}>
            <div className={styles.investmentsSectionContent}>
              <button className={styles.headerBtn} type="button">
                My investments
              </button>
            </div>
          </div>
        )}

        <div className={styles.apySection}>
          <div className={styles.apySectionContent}>
            <button className={styles.headerBtn} type="button">
              APY
            </button>
          </div>
        </div>

        <div className={styles.totalLockedSection}>
          <div className={styles.totalLockedSectionContent}>
            <button className={styles.headerBtn} type="button">
              Total Value Locked
            </button>
          </div>
        </div>

        <div className={styles.expandSection} />
      </div>

      <div className={styles.list}>
        {vaults.map((vault: any, index: number) => (
          <VaultCard key={`${vault.token0Name}/${vault.token1Name}-${index}`} vault={vault} />
        ))}
      </div>
    </div>
  );
};

export default VaultsList;
